<template>
  <div class="factoryTools">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="检验单" name="first">
          <span class="childTabs" 
          @click="qcOrderChange('FQC')" :class="{ activeLink: settingType == 'FQC' }">FQC检验单</span>
          <span class="childTabs" 
          @click="qcOrderChange('OQC')" :class="{ activeLink: settingType == 'OQC' }">OQC检验单</span>
          <span class="childTabs" 
          @click="qcOrderChange('CHECK')" :class="{ activeLink: settingType == 'CHECK' }">验货记录</span>
          <div class="btnBox">
            <div class="searchBtnBox" style="margin-right:15px">
              <el-tooltip v-if="tabPaneValue == 'first' && (settingType=='FQC' || settingType=='OQC')" class="item" content="只看我的送检单" placement="bottom" :open-delay="300">
                <el-checkbox v-model="searchConditionForm.onlyMy" @change="getQcCheckListSearch" >我的送检单</el-checkbox>
              </el-tooltip>
            </div>
            <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="addNewBtn">新建</el-button> -->
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button v-if="settingType=='FQC' || settingType=='OQC'" type="primary" icon="el-icon-download" size="small" @click="QCOrderExport">导出</el-button>
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            </div>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button class="btn_more" :class="{ activeUserMore: isMoreSearch }" size="small" icon="el-icon-d-arrow-right" @click="moreSearchBtn"></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>     
        <el-tab-pane v-for="(item, index) in tabPaneList" :key="item.id" :label="item.orderNumber" :name="item.id">
          <span slot="label">
            {{ item.orderNumber }}
            <i class="el-icon-circle-close" @click.stop="closeTabPane(index)"></i>
          </span>
          <span class="childTabs" :class="{ activeLink: cutDetail == 'detail' }" @click="cutDetailChange('detail')">检验单详情</span>
          <span class="childTabs" :class="{ activeLink: cutDetail == 'checkList' }" @click="cutDetailChange('checkList')">产品列表</span>
          <div v-if="cutDetail == 'detail'" class="btnBox">
            <div class="searchBtnBox">
              <el-button type="primary" size="small" @click="reCheck">重检</el-button>
              <el-button type="primary" size="small" @click="verify">审核</el-button>
            </div>
          </div>
          <div v-if="cutDetail == 'checkList'" class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button v-if="cutDetail == 'checkList'" icon="el-icon-download" type="primary" size="small" @click="QCOrderExportSn">导出</el-button>
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            </div>
            <el-tooltip v-if="cutDetail == 'checkList'" class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button class="btn_more" :class="{ activeUserMore: isMoreSearch }" size="small" icon="el-icon-d-arrow-right" @click="moreSearchBtn"></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>   
      </el-tabs>
      <!-- 查询条件 -->
      <el-form v-if="cutDetail == 'checkList' && tabPaneValue != 'first' && isMoreSearch"
        :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input v-model="searchConditionForm2.sn" clearable />
          </el-form-item>
          <el-form-item label="UUID" size="small">
            <el-input v-model="searchConditionForm2.uuid" clearable />
          </el-form-item>
          <el-form-item label="MAC" size="small">
            <el-input v-model="searchConditionForm2.mac" clearable />
          </el-form-item>
        </div>
      </el-form> 
      <el-form v-if="tabPaneValue == 'first' && isMoreSearch && (settingType=='FQC' || settingType=='OQC')"
        :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="检验单号" size="small">
            <el-input v-model="searchConditionForm.orderNumber" :placeholder="this.settingType=='FQC' ? 'FQC单号' : 'OQC单号'" clearable
              @keyup.enter.native="getQcCheckListSearch()" />
          </el-form-item>
          <el-form-item label="抽检批次" size="small">
            <el-input v-model="searchConditionForm.partLot" placeholder="抽检批次" clearable
              @keyup.enter.native="getQcCheckListSearch()" />
          </el-form-item>
          <el-form-item label="生产单号" size="small">
            <el-input v-model="searchConditionForm.productionOrder" :placeholder="this.settingType=='FQC' ? '组装单号' : '包装单号'" clearable
              @keyup.enter.native="getQcCheckListSearch()" />
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchConditionForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="searchConditionForm.productId"
              placeholder="请先选择产品类别"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送检时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDateTime"
              type="datetime"
              placeholder="送检开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="startDateChange('searchConditionForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDateTime"
              type="datetime"
              placeholder="送检结束时间"
              @change="endDateChange('searchConditionForm')"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="searchConditionForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" size="small">
            <el-select
              v-model="searchConditionForm.status"
              placeholder="选择状态"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.orderStatus"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有者" size="small">
            <el-select
              v-model="searchConditionForm.userId"
              placeholder="送检员或检验员"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'searchConditionForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>          
          <el-form-item v-if="this.settingType=='OQC'" label="SAP单号" size="small">
            <el-input v-model="searchConditionForm.aufnr" placeholder="SAP单号" clearable />
          </el-form-item>
        </div>
      </el-form>      
      <el-form v-if="tabPaneValue == 'first' && isMoreSearch && settingType=='CHECK'"
        :inline="true" :model="searchCheckForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input v-model="searchCheckForm.sn" clearable />
          </el-form-item>
          <el-form-item label="UUID" size="small">
            <el-input v-model="searchCheckForm.uuid" clearable />
          </el-form-item>
          <el-form-item label="MAC" size="small">
            <el-input v-model="searchCheckForm.mac" clearable />
          </el-form-item>
          <el-form-item label="组装单号" size="small">
            <el-input v-model="searchCheckForm.productionOrder" clearable />
          </el-form-item>
          <el-form-item label="包装单号" size="small">
            <el-input v-model="searchCheckForm.cartonOrder" clearable />
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="searchCheckForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="searchCheckForm.startDateTime"
              type="datetime"
              placeholder="送检开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="startDateChange('searchCheckForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchCheckForm.endDateTime"
              type="datetime"
              placeholder="送检结束时间"
              @change="endDateChange('searchCheckForm')"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form> 
    </div>
    <!-- 送检单列表 -->
    <div class="contentBox">
      <div v-if="tabPaneValue == 'first'" class="rightContent">
        <fqcOrderListPage ref="fqcOrderListPage" :tabPaneValue="tabPaneValue" :tabPaneList=tabPaneList :settingType=settingType :pagination="pagination" :searchConditionForm="searchConditionForm"></fqcOrderListPage>
        <oqcOrderListPage ref="oqcOrderListPage" :tabPaneValue="tabPaneValue" :tabPaneList=tabPaneList :settingType=settingType :pagination="pagination" :searchConditionForm="searchConditionForm"></oqcOrderListPage>
        <customerChecRecordkPage ref="customerChecRecordkPage" :tabPaneValue="tabPaneValue" :tabPaneList=tabPaneList :settingType=settingType :pagination="pagination" :searchCheckForm="searchCheckForm"></customerChecRecordkPage>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getQcCheckListSearch"
        ></pagination>
      </div>   
      <div class="rightContent"  v-else>
          <detailPage
          ref="detailPage"
          v-if="cutDetail == 'detail'"
          :tabPaneValue="tabPaneValue"
        ></detailPage>
        <checkListPage
          ref="checkListPage"
          v-else-if="cutDetail == 'checkList'"
          :tabPaneValue="tabPaneValue"
        ></checkListPage>
      </div>
    </div>    
    <myDialog ref="myDialog" width="680px"
      :title="dialogTitle" @submitData="submitData" @dialogClose="dialogClose"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
        <div v-if="dialogTitle == '新增送检单'">
          <el-form-item label="送检数量" size="small" class="inlineItem">
            <el-input v-model="dialogForm.batchQuantity"/>
          </el-form-item>
          <el-form-item label="送检员" size="small" class="inlineItem">
            <el-input v-model="dialogForm.createUser.name" :readonly="true"/>
          </el-form-item>
          <el-form-item label="送检设备SN" size="small">
            <el-input  v-model="dialogForm.sns"  type="textarea" rows="30" />
          </el-form-item>
        </div>
        <div v-if="dialogTitle == '重检'">
          <el-form-item label="抽检结果：" size="small" class="inlineItem">
            <el-radio v-model="dialogForm.status" label="0">合格</el-radio>
            <el-radio v-model="dialogForm.status" label="1">不合格</el-radio>
          </el-form-item>
        </div>
        <div v-if="dialogTitle == '审核'">
          <el-form-item label="审核结果：" size="small" class="inlineItem">
            <el-radio v-model="dialogForm.status" label="0">审核通过</el-radio>
            <el-radio v-model="dialogForm.status" label="1">审核不通过</el-radio>
          </el-form-item>
        </div>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import detailPage from "./components/detailPage.vue";
import checkListPage from "./components/checkListPage.vue";
import fqcOrderListPage from '@/view/qc/components/fqcOrderListPage'
import oqcOrderListPage from '@/view/qc/components/oqcOrderListPage'
import customerChecRecordkPage from '@/view/qc/components/customerChecRecordkPage'
import {
  apiQcCheckListDelete,
  apiCustomerList,
  apiQcOrderExport,
  apiQcOrderExportSn,
  apiQcUpdateStatus,
  apiVerify,
  apiQcBackCheck,
} from "@/api/qcOrder.js";
import{  apiProductList,apiProductTypeList,} from "@/api/productionOrder.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/qc", subTabs: { settingType: ["FQC", "OQC", "CHECK"] } },
  components: {
    pagination,
    myDialog,
    orderTableSelect,
    detailPage,
    checkListPage,
    fqcOrderListPage,
    oqcOrderListPage,
    customerChecRecordkPage
},
  data() {
    return {
      tabPaneValue: "first",
      settingType: "FQC",
      isMoreSearch: false,
      tabPaneList: [],
      tabPaneData: {},
      searchConditionForm: {},
      searchConditionForm2: {},
      searchCheckForm:{},
      pullDownData: {
        productTypeList: [],
        productList: [],
        customerList:[],
        orderStatus:[{
          value: '-1',
          label: '待检验'
        }, {
          value: '0',
          label: '合格'
        }, {
          value: '1',
          label: '不合格'
        }, {
          value: '2',
          label: '条件通过'
        }]
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      cutDetail: "detail",
      dialogTitle: "",
      dialogForm: {
        productionOrder:{},
        createUser:{},
      },
      dialogRules: {
        
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        this.getQcCheckListSearch()
        this.callback();
      } else {
        this.$nextTick(() => {
          this.tabPaneList.forEach((item) => {
            if (item.id == newVal) {
              this.tabPaneData = item;
            }
          });
          if (this.cutDetail == "detail") {
            this.$refs.detailPage.detail();
          } else if (this.cutDetail == "checkList") {
            this.$refs.checkListPage.detailSn(this.searchConditionForm2);
          }
        });
      }
    },
    
  },
  methods: {
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    //切换二级面包
    twoTabPaneClick(value){
      this.twoTabPaneValue = value;
    },
    // 关闭一级面板
    closeTabPane(index) {
      if (this.tabPaneList[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 关闭二级面板
    twoCloseTabPane(index) {
      if (this.tabPaneList[index].itemCode == this.twoTabPaneValue) {
        if (index > 0) {
          this.twoTabPaneValue = this.tabPaneList[index - 1].itemCode;
        } else {
          this.twoTabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 切换详情-二级面板
    cutDetailChange(value) {
      this.cutDetail = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (value == "detail") {
          this.$refs.detailPage.detail();
        } else if (value == "checkList") {
          this.$refs.checkListPage.detailSn(this.searchConditionForm2);
        } 
      });
    },
    // 切换视图
    qcOrderChange(value) {
      this.settingType = value;
      if(value=='FQC'){
        this.$refs.fqcOrderListPage.getFQCCheckListSearch("");
      }else if(value=='OQC'){
        this.$refs.oqcOrderListPage.getOQCCheckListSearch("");
      }
      else if(value=='CHECK'){
        this.$refs.customerChecRecordkPage.getCustomerCheckRecordSearch("");
      }
      
      this.$moreSearchStyle();
    },
    // 查询条件-员工
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 员工选择表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
      this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
    },
    // 查询条件-产品类别改变
    productTypeChange(value) {
      this.$set(this.searchConditionForm, "productId", null);
      this.pullDownData.productList = [];
      if (value) {
        this.getProductList(value, "productList");
      }
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    deleteOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "删除", "检验单").then(
        async () => {
          const res = await apiQcCheckListDelete({
            id: row.id,
          });
          if (res.code == 0) {
            this.getQcCheckListSearch();                
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },
    backOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "返回送检前工序", "检验单").then(
        async () => {
          const res = await apiQcBackCheck({
            id: row.id,
          });
          if (res.code == 0) {
            this.getQcCheckListSearch();                
            this.$message({
              message: "成功返回送检前工序",
              type: "success",
            });
          }
        }
      );
    },
    addNewBtn() {
      this.dialogTitle = "新建送检单";
      this.$refs.myDialog.dialogVisible = true;
      this.getQcCheckListInit()
    },
    // 确认
    async submitData(title) {
        this.$refs.dialogForm.validate(async (valid) => {        
          if (valid) {
            let res = {};
            if (title == "重检") {
              res = await apiQcUpdateStatus({
                id:this.tabPaneValue,
                status:this.dialogForm.status
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getProductionOrderSearch();
                this.$message({
                  message: "重检成功",
                  type: "success",
                });
              }
          } else if (title == "审核") {
              res = await apiVerify({
                id:this.tabPaneValue,
                verifyState:this.dialogForm.status
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getProductionOrderSearch();
                this.$message({
                  message: "审核成功",
                  type: "success",
                });
              }
          }            
          }
        });
      
    },
    reCheck() {
      this.dialogTitle = "重检";
      this.$refs.myDialog.dialogVisible = true;
    },
    verify(){
      this.dialogTitle = "审核";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      // this.dialogForm = {
      // };
    },
    // 查询条件--开始日期
    startDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].endDate = this[formName].startDate;
      }
    },
    // 查询条件--结束日期
    endDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].startDate = this[formName].endDate;
      }
    },    
    // 表格数据
    getQcCheckListSearch() {
      this.$nextTick(()=>{
        if(this.settingType=='FQC'){
        this.$refs.fqcOrderListPage.getFQCCheckListSearch("");
        }else if(this.settingType=='OQC'){
          this.$refs.oqcOrderListPage.getOQCCheckListSearch("");
        }
        else if(this.settingType=='CHECK'){
          this.$refs.customerChecRecordkPage.getCustomerCheckRecordSearch("");
        }
      });
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
          this.searchConditionForm = {};
          this.pagination.currentPage = 1;
          this.getQcCheckListSearch();
      }
      if (this.cutDetail == 'checkList') {
          this.searchConditionForm2 = {};
          this.$refs.checkListPage.detailSn(this.searchConditionForm2);
      }
    },
    // 检验单记录导出
    QCOrderExportSn() {
      this.$confirm(`请勿频繁导出！`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiQcOrderExportSn({
          id: this.tabPaneValue,
          export: true
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      })
    },
    // 检验单记录导出
    QCOrderExport() {
      this.$confirm(`请勿频繁导出！`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiQcOrderExport({
          ...this.searchConditionForm,
          export: true,
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      })
    },
    // 确认查询
    onSearch() {
      if (this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.getQcCheckListSearch();
      } else {
        if (this.cutDetail == "checkList") {
          this.$refs.checkListPage.detailSn(this.searchConditionForm2);
        } 
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getQcCheckListSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getQcCheckListSearch();
    },    
    callback() {
      this.getCustomerList();
      this.getProductTypeList();
    },
  },
    activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      this.getQcCheckListSearch();
      this.callback();
    } else {
      if (this.cutDetail == "detail") {
         this.$refs.detailPage.detail();
      } else if (this.cutDetail == "checkList") {
        this.$refs.checkListPage.detailSn(this.searchConditionForm2);
      }
    }
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>
<style lang="less" scoped>
.none_border {width:265px; margin: left 2px;; display: -moz-inline-box; display: inline-block;}

  .fail {
    color: #f56c6c;
  }
  .tiaojian {
    color: #e6a23c;
  }
  .pass_{
    color:#67C23A;
  }
</style>